import React from 'react';
import {
  Box,
  Typography,
  Container,
  Divider,
  Link,
} from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 3,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: 1,
          }}
        >
          {/* 版权信息 */}
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontSize: '13px' }}
          >
            Copyright © {currentYear} AIstrusys 版权所有
          </Typography>
          
          {/* 备案号信息 - 集中布局 */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: 'center',
              gap: { xs: 1, sm: 3 },
              textAlign: 'center',
            }}
          >
            <Link
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                fontSize: '13px',
                '&:hover': {
                  textDecoration: 'underline',
                  color: 'primary.main',
                },
              }}
            >
              蜀ICP备2025147599号-1
            </Link>
            
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ fontSize: '13px' }}
            >
              川公网安备 51010502010999号
            </Typography>
          </Box>
        </Box>

        {/* 分割线和附加信息 */}
        <Divider sx={{ my: 2 }} />
        
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              fontSize: '12px',
              textAlign: 'center',
              opacity: 0.8,
            }}
          >
            智能学习系统管理平台 - 致力于教育科技创新
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;